import { render, staticRenderFns } from "./design.vue?vue&type=template&id=37e946df&scoped=true&"
import script from "./design.vue?vue&type=script&lang=js&"
export * from "./design.vue?vue&type=script&lang=js&"
import style0 from "./design.vue?vue&type=style&index=0&id=37e946df&scoped=true&lang=scss&"
import style1 from "./design.vue?vue&type=style&index=1&lang=scss&"
import style2 from "@/assets/design-screen.scss?vue&type=style&index=2&id=37e946df&scoped=true&lang=scss&"
import style3 from "@/assets/otp-input.scss?vue&type=style&index=3&id=37e946df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e946df",
  null
  
)

component.options.__file = "design.vue"
export default component.exports